var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-viewer"},[_c('img',{attrs:{"src":_vm.getImgUrl(_vm.currentTime, _vm.imgBasePath)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }